import React from "react";

export function Content({ children }) {
  return <>{children}</>;
}
